import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Partner} from '@/app/core/models/partner';
import {environment} from '@/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class PartnerService {

	constructor(
		private readonly http: HttpClient
	) {	}

	getPartners(): Observable<Record<string, Partner[]>> {
		return this.http.get<Record<string, Partner[]>>(`${environment.backendUrl}/partner/active`);
	}

}
